import axios from "axios";
export default class SystemRequestService {
  static async getProject(encryptedProjectId) {
    // Without a project in the URL there is nothing to load: asking the API for "undefined" answers "closed".
    if (!encryptedProjectId) {
      return false;
    }

    localStorage.setItem('loadStatus', 'loading');

    try {
      const result = await axios({
        method: "GET",
        url: `/api/getProject/${encryptedProjectId}`,
      });

      localStorage.setItem('loadStatus', 'empty');

      if (localStorage.getItem('latestRemote') == null) {
        localStorage.setItem('latestRemote', JSON.stringify(result.data));
        location.reload();
      }
      localStorage.setItem('latestRemote', JSON.stringify(result.data));

      if (result.data.status === 'closed') {
        alert('This project is finished and not longer accessible.');
      }

      return result.data;
    } catch (error) {
      localStorage.setItem('loadStatus', 'empty');
      return false;
    }
  }

  static async updateProject(postData, encryptedProjectId) {
    if (!encryptedProjectId || localStorage.getItem('loadStatus') === 'loading') {
      return false;
    }

    try {
      const result = await axios({
        method: "POST",
        url: `/api/updateProject/${encryptedProjectId}`,
        data: postData,
      });
      return result.data;
    } catch (error) {
      return false;
    }
  }

  static async systemNameExisting(systemName) {
    try {
      const result = await axios({
        method: "GET",
        url: `/api/systemNameExisting?systemName=${systemName}`,
      });
      return result.data;
    } catch (error) {
      return false;
    }
  }
}
